export const iconFontAwesomeMoneyVault = (
	<i className="fa-solid fa-vault"></i>
);
